export const APPOINTMENT_STATUSES: Record<string, common.AppointmentStatus> = {
  Booked: 'Booked',
  Confirmed: 'Confirmed',
  AtRisk: 'AtRisk',
  Rejected: 'Rejected',
  SupplierChanged: 'SupplierChanged',
  CustomerMissed: 'CustomerMissed',
  ReAppointEUMissed: 'ReAppoint (EU Missed)',
  ReAppointORMissed: 'ReAppoint (OR Missed)',
  SupplierMissed: 'SupplierMissed',
  SupplierDelayed: 'SupplierDelayed',
  Completed: 'Completed',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
};
